"use client";

import { useLayoutEffect, useState } from "react";
import type { HomeShowcaseResolvedTheme } from "@/lib/home-showcase-images";
import { useTheme } from "@/lib/useTheme";

/**
 * Theme for marketing hero screenshots. SSR and the first client paint use "dark"
 * so markup matches; after layout, follows resolvedTheme so EN dark/light paths update
 * without hydration sticking on the server-rendered light src.
 */
export function useHomeShowcaseImageTheme(): HomeShowcaseResolvedTheme {
  const { resolvedTheme } = useTheme();
  const [imageTheme, setImageTheme] = useState<HomeShowcaseResolvedTheme | null>(null);

  useLayoutEffect(() => {
    setImageTheme(resolvedTheme);
  }, [resolvedTheme]);

  return imageTheme ?? "dark";
}
